module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-list"
  }, [_c('div', {
    staticClass: "breadcrumb-bar"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'library',
        query: {
          cpid: this.$route.query.cpid
        }
      }
    }
  }, [_vm._v("书籍管理")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("批量添加书籍")])], 1)], 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v("批量设置书籍信息")])]), _vm._v(" "), _c('div', {
    staticClass: "main-box"
  }, [_c('el-form', {
    ref: "formCustom",
    attrs: {
      "inline": true,
      "label-width": "125px",
      "model": _vm.formCustom
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "书籍面码: ",
      "label-width": "120px"
    }
  }, [_c('div', {
    staticClass: "oidstyle"
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    model: {
      value: (_vm.formCustom.OID),
      callback: function($$v) {
        _vm.$set(_vm.formCustom, "OID", $$v)
      },
      expression: "formCustom.OID"
    }
  }), _vm._v(" "), _c('getOID', {
    attrs: {
      "mode": "edit",
      "code": "cover"
    },
    on: {
      "updateOID": _vm.updateOIDHandle
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "书籍品牌: ",
      "label-width": "120px"
    }
  }, [_c('BrandChose', {
    attrs: {
      "brandName": _vm.formCustom.brand,
      "doWhatTemp": "edit"
    },
    on: {
      "brandChose": _vm.brandChoseHandle
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "书籍等级: ",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    model: {
      value: (_vm.formCustom.level),
      callback: function($$v) {
        _vm.$set(_vm.formCustom, "level", $$v)
      },
      expression: "formCustom.level"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v("批量上传pdf")])]), _vm._v(" "), _c('div', {
    staticClass: "main-box"
  }, [(_vm.uploading == false) ? _c('Upload', {
    ref: "picUploader",
    staticStyle: {
      "width": "130px",
      "height": "130px"
    },
    attrs: {
      "accept": "application/pdf,application/zip",
      "type": "drag",
      "show-upload-list": false,
      "action": "/aries-api/resource/upload",
      "data": _vm.uploadPicData,
      "multiple": "",
      "before-upload": _vm.handlePicBeforeUpload,
      "on-success": _vm.handlePicSuccess
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "48px 0"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-cloud-upload",
      "size": "32",
      "color": "#3399ff"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.uploading == true) ? _c('div', [_c('Progress', {
    attrs: {
      "percent": _vm.uploadPercent,
      "status": "active"
    }
  }), _vm._v(" "), _c('span', [_vm._v("上传进度:" + _vm._s(_vm.totalNeedUpload - _vm.picUploadNum) + "/" + _vm._s(_vm.totalNeedUpload))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('List', {
    attrs: {
      "item-layout": "vertical"
    }
  }, _vm._l((_vm.uploadStatus), function(item, index) {
    return _c('ListItem', {
      key: index
    }, [_c('ListItemMeta', {
      attrs: {
        "title": item.name,
        "description": item.status
      }
    }), _vm._v(" "), _c('template', {
      slot: "extra"
    }, [(item.status == 'success') ? _c('i', {
      staticClass: "el-icon-check",
      staticStyle: {
        "color": "#44ee44",
        "font-size": "20px"
      }
    }) : _vm._e(), _vm._v(" "), (item.status != 'success') ? _c('i', {
      staticClass: "el-icon-close",
      staticStyle: {
        "color": "#ee4444",
        "font-size": "20px"
      }
    }) : _vm._e()])], 2)
  }), 1)], 1) : _vm._e()], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.multyData.length > 0) ? _c('div', [_c('el-card', [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v("请确认批量信息")])]), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.multyData,
      "stripe": "",
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "书籍名称",
      "align": "center",
      "width": "300",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticStyle: {
            "width": "220px"
          },
          model: {
            value: (scope.row.name),
            callback: function($$v) {
              _vm.$set(scope.row, "name", $$v)
            },
            expression: "scope.row.name"
          }
        })]
      }
    }], null, false, 400886709)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "书籍品牌",
      "align": "center",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('BrandChose', {
          attrs: {
            "brandName": scope.row.content.brand,
            "doWhatTemp": "edit"
          },
          on: {
            "brandChose": function (name, id, tagIndex) {
              _vm.brandChoseSingle(scope.row.name, name, id, tagIndex)
            }
          }
        })]
      }
    }], null, false, 1415944280)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "级别",
      "align": "center",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticStyle: {
            "width": "120px"
          },
          model: {
            value: (scope.row.content.level),
            callback: function($$v) {
              _vm.$set(scope.row.content, "level", $$v)
            },
            expression: "scope.row.content.level"
          }
        })]
      }
    }], null, false, 2470443968)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "书面码",
      "align": "center",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticStyle: {
            "width": "120px"
          },
          model: {
            value: (scope.row.content.OID),
            callback: function($$v) {
              _vm.$set(scope.row.content, "OID", $$v)
            },
            expression: "scope.row.content.OID"
          }
        })]
      }
    }], null, false, 1640446356)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "书籍说明",
      "align": "center",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.content.desc))])]
      }
    }], null, false, 3044713040)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "show-overflow-tooltip": "",
      "align": "center",
      "width": "150",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "info",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.row.name)
            }
          }
        }, [_vm._v("删除")])]
      }
    }], null, false, 2217919436)
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.saveCancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.saveConfirm
    }
  }, [_vm._v("确定")])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0312c674","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/book/multyaddbook.vue
// module id = 653
// module chunks = 1